import { requireNonFreeTier } from "$/lib/require-non-free-tier"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/tire-hotel/")({
  loader: async ({ context: { queryClient } }) => {
    await requireNonFreeTier(queryClient)
    return {
      crumb: "alfred.pages.tireHotel.crumbs.tireHotel",
    }
  },
})
